<template>
	<div class="loading">
		<div>
			<i class="fas fa-spinner fa-spin"></i>
			<span class="text" v-if="!hideText">{{text || 'Loading'}}&hellip;</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Spinner',
		props: ['text', 'hideText']
	};
</script>

<style>
	.inline-loader {
		display:inline-block;
		padding: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue